export default "__VITE_ASSET__cd5d4bc7__"